import {
	localSet,
	localGet
} from '../../utils/index'
const paramConfig = {
	state: {
		paramConfig: localGet("configParamData")
	},
	mutations: {
		SET_PARAM_CONFIG: (state: any, val: any) => {
			if(val.length > 0) {
				state.paramConfig = val;
				localSet("paramConfig", val);
			}
		}
	},
	actions: {
		storeParamConfig({commit}: any, data: any) {
			commit('SET_PARAM_CONFIG', data);
		}
	}
}
//const menus:any[] = [{index: 1, name: "ok", api: ["www.test.com"]}];
export default paramConfig;
